import styled from '@emotion/styled';
import { StarIcon } from '@zola/zola-ui/src/components/SvgIcons/Star';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';

export const ListInColumns = styled.p`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${SPACING.SM};
  text-align: center;

  ${MEDIA_QUERY_V2.MOBILE} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Star = styled(StarIcon)`
  width: 20px;
  height: 20px;
  color: gold;
`;
